import { Controller } from "@hotwired/stimulus"

// 前日確認メール作成用の <dialog> を開閉する。
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event?.preventDefault()
    if (this.hasDialogTarget) this.dialogTarget.showModal()
  }

  close(event) {
    event?.preventDefault()
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
  }
}
